const resumeSummary = (
  <div className="resume-boost-summary">
    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Resume Essentials</h3>
      <ul className="list-disc pl-6">
        <li>Keep it to one page—concise and impactful resumes perform best.</li>
        <li>
          Use a clean, ATS-friendly format like{' '}
          <a
            href="https://www.overleaf.com/latex/templates/jakes-resume/syzfjbzwjncs"
            className="text-blue-600 hover:text-blue-800 hover:underline"
          >
            Jake's Resume
          </a>{' '}
          to ensure your resume is easily readable by applicant tracking systems.
        </li>
        <li>Stick to standard fonts like Arial, Calibri, or Garamond for readability.</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Key Resume Sections</h3>
      <ul className="list-disc pl-6">
        <li>Include your contact info (name, phone, email, LinkedIn, GitHub if relevant).</li>
        <li>Highlight your skills—list programming languages, frameworks, and technical tools.</li>
        <li>Showcase your work experience with clear job titles, company names, and dates.</li>
        <li>
          Add a projects section if you lack work experience—demonstrate skills with real work.
        </li>
        <li>
          Education should be listed with degree, university, and relevant coursework if applicable.
        </li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Making an Impact</h3>
      <ul className="list-disc pl-6">
        <li>Start bullet points with action verbs—e.g., "Developed," "Designed," "Implemented."</li>
        <li>
          Quantify achievements—use numbers to show impact (e.g., "Increased efficiency by 30%").
        </li>
        <li>
          Use the STAR method (Situation, Task, Action, Result) to frame experience effectively.
        </li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Optimizing for ATS & Hiring Managers</h3>
      <ul className="list-disc pl-6">
        <li>
          Use standard section headings ("Work Experience," "Projects," "Skills") for ATS
          compatibility.
        </li>
        <li>Incorporate keywords from job descriptions—tailor your resume for each application.</li>
        <li>Avoid fancy designs, images, tables, or unusual formatting—they can break in ATS.</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Final Touches</h3>
      <ul className="list-disc pl-6">
        <li>Save and submit as a PDF to preserve formatting.</li>
        <li>Have a friend, mentor, or career advisor review your resume for feedback.</li>
        <li>Test readability by copying and pasting your resume into a plain text document.</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Extra Resources</h3>
      <ul className="list-disc pl-6">
        <li>
          For a detailed overview of what makes a resume great, check out the{' '}
          <a
            href="https://www.techinterviewhandbook.org/resume/#do-not-apply-to-many-jobs-at-the-same-company"
            className="text-blue-600 hover:text-blue-800 hover:underline"
          >
            Tech Interview Handbook
          </a>
          .
        </li>
      </ul>
    </div>
  </div>
);

export default resumeSummary;
